var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-chart',{ref:"barcharts",staticStyle:{"height":"180px"},attrs:{"option":_vm.option}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }